<div class="dialog">
    <div class="dialog_header">
        <a mat-dialog-close [class.disabled]="loading"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                viewBox="0 0 18 18">
                <path id="ic_close"
                    d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                    transform="translate(-204.746 755.5)" fill="#999" />
            </svg>
        </a>
        <p class="m-0">{{"employees.Import Employees list"|translate}} <span class="fontRegular font-18 light-grey-color">(1/2)</span></p>
    </div>
    <div class="dialog_content" mat-dialog-content>

        <h4>{{"employees.Here, you can import Employee list using CSV File"|translate}}</h4>

        <ng-container *ngIf="!data">
            <p class="lable">{{"employees.First, Select the company you want to import their employee list"|translate}}
            </p>

            <div class="ng-select-field">
                <ng-select ngSelectMat appearance="fill" [(ngModel)]="SelectedCompanyId"
                    [items]="CompaniesList" [virtualScroll]="true" [loading]="loadingCompanies" bindLabel="name"
                    bindValue="id" [placeholder]='"employees.The Company" | translate'
                    [notFoundText]='"general.No Data Found" | translate' [loadingText]='"forms.Loading..." | translate'
                    (search)="dropSearch($event)" (clear)="dropSearch($event)" (blur)="dropSearch($event)"
                    (scroll)="onCompaniesScroll($event)" (scrollToEnd)="onCompaniesScrollToEnd()"
                    (change)="GetTempleat()" dropdownPosition="bottom" [clearable]="false">
                    <!-- <ng-template ng-header-tmp *ngIf="CompaniesList?.length && !loadingCompanies">
                        <small class="form-text text-muted">{{'forms.Loaded' | translate}} {{CompaniesList.length}}
                            {{'forms.of' | translate}} {{companiesCount}}</small>
                    </ng-template> -->
                    <ng-template ng-option-tmp let-item="item" let-index="index">
                        <div title="{{item.name}}">{{item.name}}</div>
                    </ng-template>
                </ng-select>
            </div>
            <!-- </mat-form-field> -->

        </ng-container>



        <p class="lable">{{"employees.Import_hint_1"|translate}}</p>
        <div *ngIf='LoadingTemplate' class="dataLoading py-5">
            <mat-spinner class="m-auto" diameter="50"></mat-spinner>
        </div>
        <app-files-viewer class="mb-4" *ngIf="Template && !LoadingTemplate"
            [files]="[{name:'نموذج قائمة الموظفين - Employees List EXCEL Template.xlsx',download:Template,type:'xlsx'}]"></app-files-viewer>

        <p class="lable">
            {{"employees.Now, Attach employees list easily"|translate}}
        </p>

        <app-file-manager [allowedExt]="['xlsx']" (selectedFiles)="OnSelectFile($event)" [maxFiles]="1" [maxFileSize]="5"
            [isRequired]="true" [label]="'employees.Attaching employee list'|translate"></app-file-manager>

    </div>

    <div class="dialog_actions" mat-dialog-actions>
        <button mat-button mat-dialog-close [disabled]="loading"
            class="btn-secondary">{{"general.Cancel"|translate}}</button>
        <button mat-button [disabled]="!Template || !SelectedFile || loading" [ngClass]="{'loading': loading}"
            class="btn-primary" (click)="CheckUploadedFile()">
            {{"employees.Import Employees list"|translate}}
        </button>
    </div>

</div>